import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLogs } from "../../../../store/slices/logsSlice";
import { useSearchParams } from "react-router-dom";
import TitleSection from "../../../@components/titleSection";
import Loader from "../../../@components/loader";
import {Table} from "react-bootstrap";
import AdminTableItem from "../parserLogs/components/adminTableItem";
import Pagination from "../../../@components/pagination";

const ParserLogs = () => {
    const dispatch = useDispatch();
    const { logs, logsLoading, logsPagination, foundCount, notFoundCount, productsCount, brands} = useSelector((state) => state.logs);

    const [searchParams, setSearchParams] = useSearchParams();
    const [searchInputValue, setSearchInputValue] = useState(searchParams.get("q") || "");
    const [foundFilter, setFoundFilter] = useState(searchParams.get("found") || "");
    const [noBrandOnly, setNoBrandOnly] = useState(searchParams.get("noBrand") === "true");


    useEffect(() => {
        const page = parseInt(searchParams.get("page")) || 1;
        const brand = searchParams.get("q") || "";
        const found = searchParams.get("found") || "";
        const noBrand = searchParams.get("noBrand") === "true";


        dispatch(getLogs({ page, brand, found, noBrand }));
    }, [dispatch, searchParams]);

    const handlePageChange = (newPage) => {
        const params = {
            page: newPage.toString(),
            q: searchInputValue,
        };
        if (foundFilter) params.found = foundFilter;

        setSearchParams(params);
    };


    const handleSearch = (e) => {
        e.preventDefault();
        const params = {
            page: "1",
            q: searchInputValue,
        };
        if (foundFilter) params.found = foundFilter;
        if (noBrandOnly) params.noBrand = "true";


        setSearchParams(params);
    };

    const handleInputSearchChange = (e) => {
        setSearchInputValue(e.target.value);
    };

    return (
        <>
            <form onSubmit={handleSearch} className="filter-form" style={{display: 'flex', gap: '15px'}}>
                <select
                    id="headerSearch"
                    className="product-search__select"
                    onChange={handleInputSearchChange}
                    value={searchInputValue}
                    style={{width: '300px'}}
                >
                    <option value="">Все бренды</option>
                    {brands?.map((brand) => (
                        <option key={brand} value={brand}>
                            {brand}
                        </option>
                    ))}
                </select>
                <select
                    value={foundFilter}
                    onChange={(e) => setFoundFilter(e.target.value)}
                    className='product-search__select'
                >
                    <option value="">Все</option>
                    <option value="true">Найденные</option>
                    <option value="false">Не найденные</option>
                </select>
                <label style={{display: "flex", alignItems: "center", gap: "8px"}}>
                    <input
                        type="checkbox"
                        checked={noBrandOnly}
                        onChange={(e) => setNoBrandOnly(e.target.checked)}
                    />
                    Без бренда
                </label>
                <button type="submit">Фильтр</button>


            </form>

            <div className="admin-body__top">
                <TitleSection redLine={false}>Logs</TitleSection>

            </div>
            <div>
                <div>Количество товаров: {productsCount}</div>
                <div>Найденные: {foundCount}</div>
                <div>Ненайденные: {notFoundCount}</div>
            </div>

            {logsLoading === 'loading' ? (
                <Loader withHeight={300}/>
            ) : (
                <div className="admin-table__wrap">
                    <Table striped bordered hover className="admin-table">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>SKU</th>
                            <th>Название</th>
                            <th>Ссылка Kanzler</th>
                            <th>Цена</th>
                            <th>Бренд</th>
                            <th>Найден</th>
                        </tr>
                        </thead>
                        <tbody>
                        {logs.length > 0 ? (
                            logs.map((el, ind) => (
                                <AdminTableItem key={el._id} item={el} ind={ind}/>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={7} className="text-center">Нет данных</td>
                            </tr>
                        )}
                        </tbody>
                    </Table>
                </div>
            )}

            <Pagination productsPagination={logsPagination}/>

        </>
    );
};

export default ParserLogs;
